import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";
import Barcode from "react-barcode";
import { useNavigate } from "react-router";

const PrintBarcodes = React.forwardRef(({ barcode_array }, ref) => (
  <div ref={ref}>
    {barcode_array?.map((barcode, index) => (
      <div key={index} className={styles.barcode_container}>
        <div className={styles.barcode_text}>
          <Barcode value={barcode.barcode} />
        </div>
        <p>Tag name: {barcode.tag_name}</p>
      </div>
    ))}
  </div>
));

const Table = ({ 
  data, 
  className, 
  activeTable, 
  setActiveTable,
  printRef 
}) => {
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleChange = (id) => {
    setSelectedFilters(prev => 
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handleRowClick = (item) => {
    navigate(`/settingsDashboard/camera&Barcode/actionBarcodesForTag/${item.id}`);
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, { [styles.active]: activeTable })}>
          <div className={styles.col}>Barcode</div>
          <div className={styles.col}>Tag</div>
          <div className={styles.col}>Created On</div>
          <div className={cn(styles.col, styles.download_text)}></div>
        </div>
        {data?.map((setting, index) => (
          <Row
            item={setting}
            key={index}
            activeTable={activeTable}
            setActiveTable={setActiveTable}
            activeId={activeId}
            setActiveId={setActiveId}
            value={selectedFilters.includes(setting.id)}
            onChange={() => handleChange(setting.id)}
            onRowClick={() => handleRowClick(setting)}
          />
        ))}
      </div>
      <div style={{ display: "none" }}>
        <PrintBarcodes 
          ref={printRef}
          barcode_array={data} 
        />
      </div>
    </div>
  );
};

export default Table;
